'use client';

import React from 'react';
import { Button, Chip } from '@heroui/react';
import { Typography } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';
import { StatsCardsProps } from '../types';

const StatsCards: React.FC<StatsCardsProps> = ({
  totalEarned = 0,
  pendingAmount = 0,
  refundedAmount = 0,
  totalPaid = 0,
  available = 0,
  onOpenPayoutHistory,
}) => {
  const { t } = useTranslations();

  // Ensure values are numbers
  const safeTotal = Number(totalEarned) || 0;
  const safePending = Number(pendingAmount) || 0;
  const safeRefunded = Number(refundedAmount) || 0;
  const safePaid = Number(totalPaid) || 0;
  const safeAvailable = Number(available) || 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 md:gap-4 max-md:border border-tin max-md:rounded-3">
      {/* Total Earned Card */}
      <div className="md:bg-white max-md:border-b md:border border-tin md:rounded-3 p-4">
        <Typography variant="body3" className="text-auth-muted mb-2">
          {t('partner.revshare.income.stats.totalEarned')}
        </Typography>
        <Typography variant="h4" className="md:font-semibold text-gray-900 mb-2">
          ${safeTotal.toFixed(2)}
        </Typography>
        {/* <div className="flex items-center gap-2 flex-wrap">
          <div className="flex items-center gap-1">
            <Typography variant="body3" className="text-auth-muted">
              {t('partner.revshare.income.stats.pending')}:
            </Typography>
            <Chip
              size="sm"
              classNames={{
                base: "bg-[#DAF5E1] rounded-2 h-6 px-2",
                content: "text-successDeep text-xs font-medium p-0",
              }}
            >
              ${safePending.toFixed(2)}
            </Chip>
          </div>
          <div className="flex items-center gap-1">
            <Typography variant="body3" className="text-auth-muted">
              {t('partner.revshare.income.stats.refunded')}:
            </Typography>
            <Chip
              size="sm"
              classNames={{
                base: "bg-[#FFD5E0] rounded-2 h-6 px-2",
                content: "text-dangerDeep text-xs font-medium p-0",
              }}
            >
              ${safeRefunded.toFixed(2)}
            </Chip>
          </div>
        </div> */}
      </div>

      {/* Total Paid Card */}
      <div className="md:bg-white max-md:border-b md:border border-tin md:rounded-3 p-4">
        <Typography variant="body3" className="text-auth-muted mb-2">
          {t('partner.revshare.income.stats.totalPaid')}
        </Typography>
        <Typography variant="h4" className="md:font-semibold text-gray-900 mb-2">
          ${safePaid.toFixed(2)}
        </Typography>
        {/* <Button
          variant="light"
          size="sm"
          className="p-0 h-auto min-w-0 text-partner text-sm font-medium"
          onPress={onOpenPayoutHistory}
        >
          {t('partner.revshare.income.stats.history')}
        </Button> */}
      </div>

      {/* Available Card */}
      <div className="md:bg-white md:border border-tin md:rounded-3 p-4">
        <Typography variant="body3" className="text-auth-muted mb-2">
          {t('partner.revshare.income.stats.available')}
        </Typography>
        <Typography variant="h4" className="md:font-semibold text-gray-900">
          ${safeAvailable.toFixed(2)}
        </Typography>
      </div>
    </div>
  );
};

export default StatsCards;
